/**
 * Copyright (c) 2026, CheckPlus Limited
 */
import React, { Component } from "react";
import "./ZhTeam.css";
import { Link } from "react-router-dom";
import { renderHomePageHeader } from "../../assets/component/renderHomePageHeader.js";
import { Helmet } from "react-helmet";
import HomepageMenuZh from "../../assets/component/HomepageMenuZh/HomepageMenuZh.js";

class ZhTeam extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showModal: false,
    };
    this.showModal = this.showModal.bind(this);
    this.closeModal = this.closeModal.bind(this);
  }
  componentDidMount() {
    window.scrollTo(0, 0);
  }
  showModal() {
    this.setState({
      showModal: true,
    });
  }

  closeModal() {
    this.setState({
      showModal: false,
    });
  }
  render() {
    return (
      <div className="ZhTeam-view">
        <Helmet>
          <title>創辦人 - CheckPlus</title>
        </Helmet>
        {!!this.state.showModal && (
          <HomepageMenuZh closeModal={this.closeModal} />
        )}
        {renderHomePageHeader(this)}

        <div className="ZhTeam-first">
          <div className="ZhTeam-heading">創辦人</div>
        </div>

        <div className="ZhTeam-second">
          <div className="ZhTeam-centerContainer">
            <div className="ZhTeamContainer">
              <div className="ZhTeam-edwardPic" />
              <div className="ZhTeam-name">
                <strong>賴鈞豪 Edward Lai</strong> <br />
                創辦人、行政總裁兼首席設計師
              </div>

              <Link to="/ZhEdward">
                <div className="ZhTeam-learnContainer">
                  <div className="ZhTeam-learnTxt">了解更多</div>
                  <div className="ZhTeam-learnArrow" />
                </div>
              </Link>
            </div>

            <div className="ZhTeamContainer">
              <div className="ZhTeam-rixPic" />
              <div className="ZhTeam-name">
                <strong>賴鈞庭 Rix Lai</strong> <br /> 創辦人
              </div>

              <Link to="/ZhRix">
                <div className="ZhTeam-learnContainer">
                  <div className="ZhTeam-learnTxt">了解更多</div>
                  <div className="ZhTeam-learnArrow" />
                </div>
              </Link>
            </div>
          </div>
        </div>

        <div className="ZhTeam-third">
          <div className="ZhTeam-thirdTxt">
            <div className="ZhTeam-thirdHeading">我們的故事</div>
            <p />
            我們的兩位創辦人一直相信，
            透過科技，我們所有的生活都會變得更加簡單。
          </div>
        </div>

        <div className="ZhTeam-fourth">
          <div className="ZhTeam-fourthTxt">
            有一天，我們的兩位創辦人坐在咖啡廳討論香港非牟利機構的網上捐款方法及難處。
          </div>
        </div>

        <div className="ZhTeam-fifth">
          <div className="ZhTeam-fifthContainer">
            <div className="ZhTeam-messageBubble" />

            <div className="ZhTeam-fifthTxt">
              當他們跟一些非牟利機構交談時，
              他們終於明白了建立和維護網上捐款的成本極高。
            </div>
          </div>
        </div>

        <div className="ZhTeam-sixth">
          <div className="ZhTeam-sixthContainer">
            <div className="ZhTeam-lightBulb" />
            <div className="ZhTeam-sixthTxt">
              他們問自己一個問題，
              <p />
              <h4>
                “可以有一個網上捐款管理工具允許捐贈者在不到一分鐘的時間內快速捐款？”
              </h4>
            </div>
          </div>
        </div>

        <div className="ZhTeam-seventh">
          <div className="ZhTeam-seventhContainer">
            <div className="ZhTeam-birthdayIcn" />
            <div className="ZhTeam-seventhTxt">
              CheckPlus 的誕生就是為了簡化非牟利機構的整個捐款程序。
            </div>
          </div>
        </div>

        <div className="ZhTeam-eighth">
          <div className="ZhTeam-eighthTxt">
            許多人問創辦人為什麼將他們的公司命名為 CheckPlus。
          </div>
        </div>

        <div className="ZhTeam-nineth">
          <div className="ZhTeam-checkMark" />

          <div className="ZhTeam-ninethTxt">
            <div className="ZhTeam-ninethHeading">CheckPlus 是卓越的意思。</div>
            <p />
            每個產品都必須具有出色的設計，同時，所有產品都必須易於使用。
            我們的創辦人相信他們在 CheckPlus 所做的一切都採用了相同的思維方式。
          </div>
        </div>

        <div className="ZhTeam-tenth">
          <div className="ZhTeam-tenthContainer">
            <div className="ZhTeam-tenthIcn" />

            <div className="ZhTeam-tenthTxt">
              <div className="ZhTeam-tenthHeading">我們 Logo 的起源</div>
              <p />
              我們的創辦人想要一個簡單的 Logo，人們亦很容易識別出含義。
              <p />
              CheckPlus
              是一間科技開發公司。代碼是應用程式的溝通方法，而開關引號就是代碼的開始和結束。
              <p />
              我們的 Logo 也代表區塊鍊的連繫和一條沒有盡頭流動的河流。
              這意味著與時並進的意思及創造一個更好未來的一份盼望。
            </div>
          </div>
        </div>

        <div className="ZhTeam-footer">
          <div className="ZhTeam-footerNav">
            <Link to="/ZhTeam">
              <div className="ZhTeam-footerNavItem">創辦人的故事</div>
            </Link>
            <Link to="/ZhFaq">
              <div className="ZhTeam-footerNavItem">常見問題</div>
            </Link>
            <Link to="/ZhContact">
              <div className="ZhTeam-footerNavItem">聯絡我們</div>
            </Link>

            <Link to="/ZhPrivacyPolicy">
              <div className="ZhTeam-footerNavItem">私隱政策</div>
            </Link>

            <Link to="/ZhTerms">
              <div className="ZhTeam-footerNavItem">使用條款</div>
            </Link>
          </div>

          <div className="ZhTeam-footer_text">
            香港九龍油塘四山街 11 號
            <br />
            華利工業大廈 5 樓 A 室
            <br />
            <p />
            Copyright © 2026 CheckPlus Ltd. 保留一切權利。
          </div>
        </div>
      </div>
    );
  }
}

export default ZhTeam;
